import { useContext } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { getObjectValue } from 'utilities';
import getOptionsAccordingApproach from './getOptionsAccordingApproach';
import multipleTypeApproachListStyles from './MultipleTypeApproachSelect.styles';
import { MultipleTypeApproachProps } from './types';
import DCFTVTContext from '../../context/DCFTVTContext';

const MultipleTypeApproachSelect = (props: MultipleTypeApproachProps) => {
  const { cell, dcfWacc } = getObjectValue(props);
  const { revenueMultipleOptions, ebitdaMultipleOptions } = useContext(DCFTVTContext);
  const options = getOptionsAccordingApproach({
    dcfWacc,
    cell,
    revenueMultipleOptions: revenueMultipleOptions as string[],
    ebitdaMultipleOptions: ebitdaMultipleOptions as string[],
  });

  return (
    <GridSelect
      extraStyles={multipleTypeApproachListStyles}
      options={options}
      optionsTextAlign="right"
      useHandleChange={false}
      {...props}
    />
  );
};

export default MultipleTypeApproachSelect;
